import { supportsLocalStorage } from '../../app/utils/environment';
import { LOCAL_STORAGE_KEY } from '../../app/utils/persistentState';
import { ONBOARDING_VISIBILITY } from '../actions/onboarding';

/* Remove entries, i.e.
    {
        actionType: 'MY_ACTION'
        payload: 'VALUE'
    }
*/
let ENTRIES_TO_REMOVE = [];

/* Remove properties, i.e.
    {
        actionType: 'MY_ACTION', //added 2016-10-21
        property: 'VALUE'
    }
 */
let PROPERTIES_TO_REMOVE = [
    {
        // Added 2017-04-25
        actionType: ONBOARDING_VISIBILITY,
        property: 'channels',
    },
    {
        // Added 2017-04-25
        actionType: ONBOARDING_VISIBILITY,
        property: 'continue_watching_next',
    },
];

export function setEntriesToRemove(param) {
    ENTRIES_TO_REMOVE = param;
}

export function setPropertiesToRemove(param) {
    PROPERTIES_TO_REMOVE = param;
}

export const removeOldProperties = (originalActions) => {
    let actions = Object.assign({}, originalActions);

    PROPERTIES_TO_REMOVE.map((propertyToRemove) => {
        let foundPropertiesToRemove = Object.keys(actions).map((actionType) => {
            if (!actions[actionType]) {
                return undefined;
            }

            return Object.keys(actions[actionType]).find((property) => {
                return actionType === propertyToRemove.actionType && property === propertyToRemove.property;
            });
        });

        foundPropertiesToRemove.map((property) => {
            if (property !== undefined) {
                delete actions[propertyToRemove.actionType][property];
            }
        });
    });

    return actions;
};

export const removeOldEntries = (originalActions) => {
    let actions = Object.assign({}, originalActions);

    let foundEntriesToRemove = ENTRIES_TO_REMOVE.map((entryToRemove) => {
        return Object.keys(actions).find((actionType) => {
            return actionType === entryToRemove.actionType && actions[actionType].id === entryToRemove.id;
        });
    });

    foundEntriesToRemove.map((entry) => {
        if (entry !== undefined) {
            delete actions[entry];
        }
    });

    return actions;
};

// Actions created with a "persistent" flag (set to true) will be stored in local storage.
export const persistentState = (store) => (next) => (action) => {
    if (action.persistent === true && supportsLocalStorage()) {
        let actions = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');

        let newValue = action.payload;
        if (actions.hasOwnProperty(action.type)) {
            let original = actions[action.type];

            if (typeof original === 'object') {
                newValue = Object.assign({}, original, action.payload);
            }
        }

        actions[action.type] = newValue;

        //remove outdated stuff from localstorage e.g. after A/B tests
        actions = removeOldEntries(actions);
        actions = removeOldProperties(actions);

        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(actions));
    }

    return next(action);
};

export default persistentState;
